export const EXTENSION_AUTH_TOKEN_COOKIE_NAME = "mem_extension_token";
